import { createRouter, createWebHistory } from "vue-router";
import auth from "@/router/auth";
import Login from "../views/LoginUser.vue";
import RegisterUser from "../views/RegisterView.vue";
import RecoverPassword from "../components/ForgotPassword.vue";
import RFIManagement from "@/components/rfi-management/RFIManagement.vue";
import RFIDashboard from "@/components/rfi-dashboard/RFIDashboard.vue";
import RFIForm from "@/components/rfi-management/RFIForm.vue";
import ColumnsSelector from "@/components/ColumnsSelector.vue";

const routes = [
  {
    path: "/",
    redirect: "/login",
    meta: { middleware: auth },
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: { middleware: auth },
  },
  {
    path: "/register",
    name: "RegisterUser",
    component: RegisterUser,
    meta: { middleware: auth },
  },

  {
    path: "/recover-password",
    name: "RecoverPassword",
    component: RecoverPassword,
    meta: { middleware: auth },
  },

  {
    path: "/rfi-management",
    name: "RFI Management",
    component: RFIManagement,
    meta: { middleware: auth },
  },
  {
    path: "/rfi-dashboard",
    name: "RFI Dashboard",
    component: RFIDashboard,
    meta: { middleware: auth },
  },
  {
    path: "/new-rfi",
    name: "RFIForm",
    component: RFIForm,
    meta: { middleware: auth },
  },
  {
    path: "/columns-selector",
    name: "ColumnsSelector",
    component: ColumnsSelector,
    meta: { middleware: auth },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || "RFIs - System";
  next();
});

router.beforeEach(async (to, from, next) => {
  if (to.meta.middleware) {
    try {
      await auth(to, from, next);
    } catch (error) {
      console.error("Middleware error:", error);
      next({ name: "login" });
    }
  } else {
    next();
  }
});

export default router;
